module.exports = "/images/cooking.gif";